@if (showShell()) {
  <app-layout>
    <router-outlet />
  </app-layout>
} @else {
  <router-outlet />
}
<app-toast-host />
